module.exports = __webpack_public_path__ + "img/chair.828c5633.png";